import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setUnsavedTyping } from '@/shared/utils/appVersionStore';
import { scheduleIdlePrefetch } from '@/shared/utils/chunkPrefetch';
import { startNewVersionPolling } from '@/shared/utils/newVersionDetection';
import { trackUnsavedTyping } from '@/shared/utils/unsavedTypingTracker';
import { getZlfChunkLoaders } from './useZlfTranslation';

/**
 * 掛在登入後的版面外殼：偵測新版本、記錄是否有未儲存的輸入，並在閒置時預載所有 chunk。
 * 三者互相獨立，任何一個失敗都不影響頁面。
 */
export function useAppVersionWatch(isAuthenticated: boolean): void {
    const { pathname } = useLocation();

    useEffect(() => trackUnsavedTyping(), []);
    useEffect(() => startNewVersionPolling(), []);

    // 換頁後輸入已隨舊頁面消失；表單何時送出無從得知，所以只在換頁時歸零
    useEffect(() => setUnsavedTyping(false), [pathname]);

    useEffect(() => {
        if (!isAuthenticated) return undefined;
        return scheduleIdlePrefetch({ extraLoaders: getZlfChunkLoaders() });
    }, [isAuthenticated]);
}
